import { render, staticRenderFns } from "./IconPoiMedical.vue?vue&type=template&id=0e35caee&"
import script from "./IconPoiMedical.vue?vue&type=script&lang=js&"
export * from "./IconPoiMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports